import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { ERRO_EMAIL_OBRIGATORIO, ERRO_FORMATO_EMAIL_INVALIDO } from 'src/app/tools/Mensagens';
import { PAGINA_LOGIN } from 'src/app/tools/URL';

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'redefinir-senha-email',
  templateUrl: './redefinir-senha-email.component.html',
  styleUrls: ['./redefinir-senha-email.component.css']
})
export class RedefinirSenhaEmailComponent implements OnInit {

  email: string;
  urlLogin = PAGINA_LOGIN;

  constructor(private authService: AuthService) {
    this.email = null;
  }

  ngOnInit() {}

  camposValidos(email) {

    if (email === null  || email === '') {

      alert(ERRO_EMAIL_OBRIGATORIO);

      return false;

    }

    if (!EMAIL_REGEX.test(email)) {

      alert(ERRO_FORMATO_EMAIL_INVALIDO);

      return false;

    }

    return true;

  }

  enviar() {

    if (this.camposValidos(this.email)) {

      this.authService.redefinirSenhaEmail(this.email);

    }

  }

}
